// extracted by mini-css-extract-plugin
export const container = "fancyBorder-module--container--3Sp9W";
export const innerBorder = "fancyBorder-module--innerBorder--3D_eo";
export const bottomBorder = "fancyBorder-module--bottomBorder--3cohb";
export const topBorder = "fancyBorder-module--topBorder--qeDd1";